// extracted by mini-css-extract-plugin
export var container = "_6v-0";
export var containerTopRight = "_6v-1";